let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fBab2")).then(() => parcelRequire('jgVvi'));